<!--
 * @Author: your name
 * @Date: 2020-08-10 10:25:18
 * @LastEditTime: 2022-12-09 17:14:36
 * @LastEditors: yggira ira1982@gmail.com
 * @Description: In User Settings Edit
 * @FilePath: /intelligent-parking/src/components/Menu.vue
-->
<template>
  <div class="menu">
    <div class="name">橙行停车管理系统</div>
    <el-menu background-color="#020c3c" text-color="#fff" active-text-color="#fff">
      <el-menu-item index="1" @click="toPage('workbench')" :class="{'is-active':$route.name=='workbench'}"> <span slot="title">门岗工作台</span> </el-menu-item>
      <el-menu-item index="2" @click="toPage('passCar')" :class="{'is-active':$route.name=='passCar'}"> <span slot="title">放行车辆管理</span> </el-menu-item>
      <el-menu-item index="3" @click="toPage('white')" :class="{'is-active':$route.name=='white'}"> <span slot="title">设定白名单</span> </el-menu-item>
    </el-menu>
  </div>
</template>
<script>
  import Util from "../Util.js";
  export default {
    name: "Header",
    components: {

    },
    data() {
      return {
        isOpen: true,
        isAdmin:false
      };
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      },
    },
    watch: {},
    mounted() {
        if(this.userInfo.userType!=1){
            this.isAdmin=true
        }
    },
    methods: {
      toPage(val) {
          if(this.$route.name==val)return
          this.$router.push({
            name: val,
          });
      }
    }
  };

</script>

<style lang="less" scoped>
  .el-submenu,
  .el-menu-item {
    min-width: 200px;
  }

  .menu {
    height: 100vh;
    background-color: #020c3c !important;

    .name {
      background: #1c2d4c;
      height: 60px;
      line-height: 60px;
      text-align: center;
      color: #fff;
      font-size: 18px;
    }

    .is-active {
      background: #409EFF !important;
    }

    .el-menu-item,
    .el-submenu__title {
      height: 46px;
      line-height: 46px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Menu.vue